import { concat, get } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { APIS } from 'src/lib/constants/apis';
import { FORM_FIELDS_TYPES, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { isTrue } from 'src/utils/helper';

// import schemas
import Schema from 'src/lib/paths/verwendungsnachweis_FULL_Paths.json';
const P = Schema.attributes;

const VNNachweisBeklebung: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			<ApplicationHeading title='Nachweis Beklebung' description={PLATZHALTER_TEXT} />

			<CreateForm
				formStruc={formStruc(application)}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
				api={APIS.Verwendungsnachweis}
			/>
		</>
	);
};
export default VNNachweisBeklebung;

const formStruc = (application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Nachweis_Der_Beklebung_Erklaerung],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	if (isTrue(get(application, P.Nachweis_Der_Beklebung_Erklaerung.path))) {
		struc.push({
			fields: [
				{
					...P.Nachweis_Der_Beklebung,
					type: FORM_FIELDS_TYPES.componentTable,
					fieldProps: { Datei: { allowOnlyImage: true } },
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		});
	}

	return struc;
};

export const getFormStrucVNDNachweisBeklebung = (application: any): FormStrucItem[] => {
	return concat(formStruc(application));
};
